/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_Pi as Pi,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_api as api,
} from "../../runtime/index.jsx";
export function BuscadorPersona(e) {
  let t = (0, ReactCompiler.c)(25),
    { onSelect: n, placeholder: r, excluirIds: i } = e,
    a = r === void 0 ? `Buscar persona…` : r,
    o;
  t[0] === i
    ? (o = t[1])
    : ((o = i === void 0 ? [] : i), (t[0] = i), (t[1] = o));
  let s = o,
    [c, l] = (0, React.useState)(``),
    u;
  t[2] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((u = []), (t[2] = u))
    : (u = t[2]);
  let [f, p] = (0, React.useState)(u),
    [m, h] = (0, React.useState)(``),
    _,
    v;
  (t[3] === c
    ? ((_ = t[4]), (v = t[5]))
    : ((_ = () => {
        let e = c.trim();
        if (e.length < 2) {
          p([]);
          return;
        }
        let t = !0,
          n = setTimeout(() => {
            api(`/usuarios?q=${encodeURIComponent(e)}`)
              .then((e) => {
                t && (p(Array.isArray(e) ? e : []), h(``));
              })
              .catch((e) => {
                t && h(e.message);
              });
          }, 250);
        return () => {
          ((t = !1), clearTimeout(n));
        };
      }),
      (v = [c]),
      (t[3] = c),
      (t[4] = _),
      (t[5] = v)),
    (0, React.useEffect)(_, v));
  let y;
  if (t[6] !== f || t[7] !== s) {
    let e;
    (t[9] === s
      ? (e = t[10])
      : ((e = (e) => !s.includes(e.id)), (t[9] = s), (t[10] = e)),
      (y = f.filter(e).slice(0, 6)),
      (t[6] = f),
      (t[7] = s),
      (t[8] = y));
  } else y = t[8];
  let b = y,
    x;
  t[11] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((x = (
        <Pi
          className={`pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-(--text)`}
        />
      )),
      (t[11] = x))
    : (x = t[11]);
  let S;
  t[12] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((S = (e) => l(e.target.value)), (t[12] = S))
    : (S = t[12]);
  let C;
  t[13] !== a || t[14] !== c
    ? ((C = (
        <div
          className={`relative`}
          children={[
            x,
            <input
              className={`w-full rounded-2xl border border-(--border) bg-(--bg) py-2 pl-9 pr-3 text-sm text-(--text-h) outline-none focus:border-(--accent-border) focus:ring-2 focus:ring-(--accent-bg)`}
              value={c}
              onChange={S}
              placeholder={a}
            />,
          ]}
        />
      )),
      (t[13] = a),
      (t[14] = c),
      (t[15] = C))
    : (C = t[15]);
  let w;
  t[16] === m
    ? (w = t[17])
    : ((w = m && <p className={`mt-1 text-xs text-(--error)`} children={m} />),
      (t[16] = m),
      (t[17] = w));
  let T;
  t[18] !== n || t[19] !== b
    ? ((T = b.length > 0 && (
        <ul
          className={`animar-entrada mt-1 overflow-hidden rounded-2xl border border-(--border) bg-(--bg) shadow-2xl`}
          children={b.map((e) => (
            <li
              key={e.id}
              children={
                <button
                  type={`button`}
                  onClick={() => {
                    let t =
                      [e.nombre, e.apellido].filter(Boolean).join(` `) ||
                      e.usuario;
                    (n({
                      id: e.id,
                      nombre: t,
                      correo: e.correo,
                    }),
                      l(``));
                  }}
                  className={`flex w-full flex-col items-start px-3 py-2 text-left text-sm transition hover:bg-(--accent-bg)`}
                  children={[
                    <span
                      className={`text-(--text-h)`}
                      children={
                        [e.nombre, e.apellido].filter(Boolean).join(` `) ||
                        e.usuario
                      }
                    />,
                    <span
                      className={`text-xs text-(--text)`}
                      children={e.correo}
                    />,
                  ]}
                />
              }
            />
          ))}
        />
      )),
      (t[18] = n),
      (t[19] = b),
      (t[20] = T))
    : (T = t[20]);
  let E;
  return (
    t[21] !== C || t[22] !== w || t[23] !== T
      ? ((E = <div children={[C, w, T]} />),
        (t[21] = C),
        (t[22] = w),
        (t[23] = T),
        (t[24] = E))
      : (E = t[24]),
    E
  );
}
